import { biometricConstants } from '../constants';
import { biometricRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const biometricActions = {}

biometricActions.GetBiometricResults = (data) => {
  return dispatch => {
    dispatch(request())//Ejecución de inicialización del "request()"
    biometricRequests.GetBiometricResults(data)//Ejecución de petición al API
      .then(//Respuesta de promesa
        bioResult => dispatch(success(bioResult)),//Respuesta correcta del API
        error => dispatch(failure(handleErrorMessage(error)))//Respuesta erronea del API
      )
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
    return { type: biometricConstants.BIO_RESULT_REQUEST }
  }

  function success(bioResult) { //Respuesta correcta de petición
    return { type: biometricConstants.BIO_RESULT_SUCCESS, bioResult } 
  }

  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: biometricConstants.BIO_RESULT_FAILURE, error } // => carpeta constants => ProductConstants.js
  }
}
///Siguiente paso => Crear reducer

